// icons - common
import IconTick from './images/common/icons/tick.png';
import IconCross from './images/common/icons/cross.png';
import IconClose from './images/common/icons/close.png';
import IconGlobe from './images/common/icons/globe.png';
import IconLocked from './images/common/icons/locked.png';
import IconHeroes from './images/common/icons/heroes.png';
import IconProfile from './images/common/icons/profile.png';
import IconOpenSea from './images/common/icons/openSea.png';
import IconDiscord from './images/common/icons/discord.png';
import IconRefresh from './images/common/icons/refresh.png';
import IconCheckmark from './images/common/icons/checkmark.png';
import IconSkyborne from './images/common/icons/mediumSkyborne.png';
import IconDropdownArrow from './images/common/icons/dropdownArrow.png';

// Homepage
// images - homepage
import ImgLogoRG from './images/home/logoRG.png';
import ImgHomeSkyBG from './images/home/skyBG.jpg';
import ImgCastleBG from './images/home/castleBG.png';
import ImgDragonBG from './images/home/dragonBG.png';
import ImgTreeDarkFG from './images/home/treeDarkFG.png';
import ImgLogoGenesis from './images/home/logoGenesis.png';
import ImgTreeTopLeft from './images/home/treeTopLeft.png';
import ImgTreeTopRight from './images/home/treeTopRight.png';
import ImgTreeBottomLeft from './images/home/treeBottomLeft.png';
import ImgTreeBottomRight from './images/home/treeBottomRight.png';
// icons  - homepage
import IconTwitch from './images/home/icons/twitch.png';
import IconMedium from './images/home/icons/medium.png';
import IconTiktok from './images/home/icons/tiktok.png';
import IconDiscord2 from './images/home/icons/discord.png';
import IconTwitter from './images/home/icons/twitter.png';
import IconYoutube from './images/home/icons/youtube.png';
import IconFacebook from './images/home/icons/facebook.png';
import IconInstagram from './images/home/icons/instagram.png';
import IconDiscordSmall from './images/home/icons/discordSmall.png';
import IconTwitterSmall from './images/home/icons/twitterSmall.png';

// Account
// images - account
import ImgAccountBG from './images/account/BG.jpg';
// icons - account
import IconArrow from './images/account/icons/arrow.png';
import IconAccountInfo from './images/account/icons/help.png';
import IconSwitchOn from './images/account/icons/switchOn.png';
import IconSwitchOff from './images/account/icons/switchOff.png';
import IconAccountSettings from './images/account/icons/settings.png';
import IconAccountActivity from './images/account/icons/activity.png';
import IconAccountBriefcase from './images/account/icons/briefcase.png';
import IconAccountSettingsActive from './images/account/icons/settingsActive.png';
import IconAccountActivityActive from './images/account/icons/activityActive.png';
import IconAccountBriefcaseActive from './images/account/icons/briefcaseActive.png';

// Map
// images - map
import ImgMapWorld from './images/map/world.jpg';
import ImgMapRegionBanner from './images/map/regionBanner.png';
import ImgMapWorldLowQuality from './images/map/worldLowQuality.jpg';

// icons - map
import IconMapInfo from './images/map/icons/info.png';
import IconMapBackpack from './images/map/icons/backpack.png';
import IconMapSideQuestPin from './images/map/icons/sideQuestPin.png';
import IconMapMergedQuestPin from './images/map/icons/mergedQuestPin.png';
import IconMapCampaignQuestPin from './images/map/icons/campaignQuestPin.png';

// Heroes
// images - heroes
import ImgAvatarFrame from './images/heroes/avatarFrame.png';
import ImgHeroTitleMotif from './images/heroes/titleMotif.png';
import ImgHeroPlaceholder from './images/heroes/heroPlaceholder.gif';
// icons - heroes
import IconHeroCheckmark from './images/heroes/icons/checkmark.png';

// Quest
// icons - quest
import IconQuests from './images/quest/icons/quest.png';
import IconQuestTheme from './images/quest/icons/theme.png';
import IconQuestAddHero from './images/quest/icons/addHero.png';
import IconQuestDuration from './images/quest/icons/duration.png';
import IconQuestSmallInfo from './images/quest/icons/smallInfo.png';
import IconQuestRemoveHero from './images/quest/icons/btnRemove.png';
import IconQuestThemeLocked from './images/quest/icons/themeLocked.png';
import IconQuestDurationBlue from './images/quest/icons/durationBlue.png';
import IconQuestThemeComplete from './images/quest/icons/themeComplete.png';

// Backpack
// images - backpack
import ImgItemPlaceholder from './images/item/itemPlaceholder.gif';

// Traits
// images - traits
// icons - traits
import IconTraitLeader from './images/trait/icons/leader.png';
import IconTraitRarityMythic from './images/trait/icons/rarityMythic.png';
import IconTraitRarityEpic from './images/trait/icons/rarityEpic.png';
import IconTraitRarityCommon from './images/trait/icons/rarityCommon.png';
import IconTraitRarityUncommon from './images/trait/icons/rarityUncommon.png';
import IconTraitRarityRare from './images/trait/icons/rarityRare.png';
import IconTraitRarityLegendary from './images/trait/icons/rarityLegendary.png';
import IconTraitSpeciesDragonkin from './images/trait/icons/speciesDragonkin.png';
import IconTraitSpeciesHuman from './images/trait/icons/speciesHuman.png';
import IconTraitSpeciesEmberling from './images/trait/icons/speciesEmberling.png';
import IconTraitSpeciesGnome from './images/trait/icons/speciesGnome.png';
import IconTraitSpeciesElf from './images/trait/icons/speciesElf.png';
import IconTraitSpeciesDwarf from './images/trait/icons/speciesDwarf.png';
import IconTraitSpeciesOrc from './images/trait/icons/speciesOrc.png';
import IconTraitSpeciesGoliath from './images/trait/icons/speciesGoliath.png';
import IconTraitElementalAffinityPyroflame from './images/trait/icons/elementalAffinityPyroflame.png';
import IconTraitElementalAffinityTerrafirm from './images/trait/icons/elementalAffinityTerrafirm.png';
import IconTraitElementalAffinityCyclonis from './images/trait/icons/elementalAffinityCyclonis.png';
import IconTraitElementalAffinityAquasurge from './images/trait/icons/elementalAffinityAquasurge.png';
import IconTraitElementalAffinityCryonyx from './images/trait/icons/elementalAffinityCryonyx.png';
import IconTraitElementalAffinityVoltanyx from './images/trait/icons/elementalAffinityVoltanyx.png';
import IconTraitElementalAffinityUmbranyx from './images/trait/icons/elementalAffinityUmbranyx.png';
import IconTraitElementalAffinitySylvanyx from './images/trait/icons/elementalAffinitySylvanyx.png';
import IconTraitElementalAffinitySolphaeon from './images/trait/icons/elementalAffinitySolphaeon.png';
import IconTraitElementalAffinityOblivaeon from './images/trait/icons/elementalAffinityOblivaeon.png';
import IconTraitElementalTier1 from './images/trait/icons/elementalTier1.png';
import IconTraitElementalTier2 from './images/trait/icons/elementalTier2.png';
import IconTraitElementalTier3 from './images/trait/icons/elementalTier3.png';
import IconTraitClassFighter from './images/trait/icons/classFighter.png';
import IconTraitClassRogue from './images/trait/icons/classRogue.png';
import IconTraitClassCleric from './images/trait/icons/classCleric.png';
import IconTraitClassDruid from './images/trait/icons/classDruid.png';
import IconTraitClassHunter from './images/trait/icons/classHunter.png';
import IconTraitClassBard from './images/trait/icons/classBard.png';
import IconTraitClassPaladin from './images/trait/icons/classPaladin.png';
import IconTraitClassMonk from './images/trait/icons/classMonk.png';
import IconTraitClassBarbarian from './images/trait/icons/classBarbarian.png';
import IconTraitClassMage from './images/trait/icons/classMage.png';
import IconTraitClassSorcerer from './images/trait/icons/classSorcerer.png';
import IconTraitRank1 from './images/trait/icons/rank1.png';
import IconTraitRank2 from './images/trait/icons/rank2.png';
import IconTraitRank3 from './images/trait/icons/rank3.png';
import IconTraitRank4 from './images/trait/icons/rank4.png';
import IconTraitRank5 from './images/trait/icons/rank5.png';
import IconTraitClassFighterRank1 from './images/trait/icons/classFighterRank1.png';
import IconTraitClassFighterRank2 from './images/trait/icons/classFighterRank2.png';
import IconTraitClassFighterRank3 from './images/trait/icons/classFighterRank3.png';
import IconTraitClassFighterRank4 from './images/trait/icons/classFighterRank4.png';
import IconTraitClassFighterRank5 from './images/trait/icons/classFighterRank5.png';
import IconTraitClassRogueRank1 from './images/trait/icons/classRogueRank1.png';
import IconTraitClassRogueRank2 from './images/trait/icons/classRogueRank2.png';
import IconTraitClassRogueRank3 from './images/trait/icons/classRogueRank3.png';
import IconTraitClassRogueRank4 from './images/trait/icons/classRogueRank4.png';
import IconTraitClassRogueRank5 from './images/trait/icons/classRogueRank5.png';
import IconTraitClassClericRank1 from './images/trait/icons/classClericRank1.png';
import IconTraitClassClericRank2 from './images/trait/icons/classClericRank2.png';
import IconTraitClassClericRank3 from './images/trait/icons/classClericRank3.png';
import IconTraitClassClericRank4 from './images/trait/icons/classClericRank4.png';
import IconTraitClassClericRank5 from './images/trait/icons/classClericRank5.png';
import IconTraitClassDruidRank1 from './images/trait/icons/classDruidRank1.png';
import IconTraitClassDruidRank2 from './images/trait/icons/classDruidRank2.png';
import IconTraitClassDruidRank3 from './images/trait/icons/classDruidRank3.png';
import IconTraitClassDruidRank4 from './images/trait/icons/classDruidRank4.png';
import IconTraitClassDruidRank5 from './images/trait/icons/classDruidRank5.png';
import IconTraitClassHunterRank1 from './images/trait/icons/classHunterRank1.png';
import IconTraitClassHunterRank2 from './images/trait/icons/classHunterRank2.png';
import IconTraitClassHunterRank3 from './images/trait/icons/classHunterRank3.png';
import IconTraitClassHunterRank4 from './images/trait/icons/classHunterRank4.png';
import IconTraitClassHunterRank5 from './images/trait/icons/classHunterRank5.png';
import IconTraitClassBardRank1 from './images/trait/icons/classBardRank1.png';
import IconTraitClassBardRank2 from './images/trait/icons/classBardRank2.png';
import IconTraitClassBardRank3 from './images/trait/icons/classBardRank3.png';
import IconTraitClassBardRank4 from './images/trait/icons/classBardRank4.png';
import IconTraitClassBardRank5 from './images/trait/icons/classBardRank5.png';
import IconTraitClassPaladinRank1 from './images/trait/icons/classPaladinRank1.png';
import IconTraitClassPaladinRank2 from './images/trait/icons/classPaladinRank2.png';
import IconTraitClassPaladinRank3 from './images/trait/icons/classPaladinRank3.png';
import IconTraitClassPaladinRank4 from './images/trait/icons/classPaladinRank4.png';
import IconTraitClassPaladinRank5 from './images/trait/icons/classPaladinRank5.png';
import IconTraitClassMonkRank1 from './images/trait/icons/classMonkRank1.png';
import IconTraitClassMonkRank2 from './images/trait/icons/classMonkRank2.png';
import IconTraitClassMonkRank3 from './images/trait/icons/classMonkRank3.png';
import IconTraitClassMonkRank4 from './images/trait/icons/classMonkRank4.png';
import IconTraitClassMonkRank5 from './images/trait/icons/classMonkRank5.png';
import IconTraitClassBarbarianRank1 from './images/trait/icons/classBarbarianRank1.png';
import IconTraitClassBarbarianRank2 from './images/trait/icons/classBarbarianRank2.png';
import IconTraitClassBarbarianRank3 from './images/trait/icons/classBarbarianRank3.png';
import IconTraitClassBarbarianRank4 from './images/trait/icons/classBarbarianRank4.png';
import IconTraitClassBarbarianRank5 from './images/trait/icons/classBarbarianRank5.png';
import IconTraitClassMageRank1 from './images/trait/icons/classMageRank1.png';
import IconTraitClassMageRank2 from './images/trait/icons/classMageRank2.png';
import IconTraitClassMageRank3 from './images/trait/icons/classMageRank3.png';
import IconTraitClassMageRank4 from './images/trait/icons/classMageRank4.png';
import IconTraitClassMageRank5 from './images/trait/icons/classMageRank5.png';
import IconTraitClassSorcererRank1 from './images/trait/icons/classSorcererRank1.png';
import IconTraitClassSorcererRank2 from './images/trait/icons/classSorcererRank2.png';
import IconTraitClassSorcererRank3 from './images/trait/icons/classSorcererRank3.png';
import IconTraitClassSorcererRank4 from './images/trait/icons/classSorcererRank4.png';
import IconTraitClassSorcererRank5 from './images/trait/icons/classSorcererRank5.png';
import IconTraitWeaponTypeMagicItem from './images/trait/icons/weaponTypeMagicItem.png';
import IconTraitWeaponTypeStaff from './images/trait/icons/weaponTypeStaff.png';
import IconTraitWeaponTypeHeavy from './images/trait/icons/weaponTypeHeavy.png';
import IconTraitWeaponTypeSword from './images/trait/icons/weaponTypeSword.png';
import IconTraitWeaponTypeRange from './images/trait/icons/weaponTypeRange.png';
import IconTraitWeaponTypeAxe from './images/trait/icons/weaponTypeAxe.png';
import IconTraitWeaponTypeDaggers from './images/trait/icons/weaponTypeDaggers.png';
import IconTraitWeaponTypeFists from './images/trait/icons/weaponTypeFists.png';
import IconTraitWeaponTypeInstrument from './images/trait/icons/weaponTypeInstrument.png';
import IconTraitWeaponTypeSpear from './images/trait/icons/weaponTypeSpear.png';
import IconTraitWeaponTier1 from './images/trait/icons/weaponTier1.png';
import IconTraitWeaponTier2 from './images/trait/icons/weaponTier2.png';
import IconTraitWeaponTier3 from './images/trait/icons/weaponTier3.png';
import IconTraitWeaponTier4 from './images/trait/icons/weaponTier4.png';
import IconTraitDamageTypeMagic from './images/trait/icons/damageTypeMagic.png';
import IconTraitDamageTypeBlunt from './images/trait/icons/damageTypeBlunt.png';
import IconTraitDamageTypeSlash from './images/trait/icons/damageTypeSlash.png';
import IconTraitDamageTypePierce from './images/trait/icons/damageTypePierce.png';
import IconTraitRoleHealer from './images/trait/icons/roleHealer.png';
import IconTraitRoleMeleeDps from './images/trait/icons/roleMeleeDps.png';
import IconTraitRoleSupport from './images/trait/icons/roleSupport.png';
import IconTraitRoleRangedDps from './images/trait/icons/roleRangedDps.png';
import IconTraitRoleTank from './images/trait/icons/roleTank.png';
import IconTraitCompanion from './images/trait/icons/companion.png';

// globals
const Icon: { [key: string]: string } = {
  // Common
  TICK: IconTick,
  CROSS: IconCross,
  GLOBE: IconGlobe,
  CLOSE: IconClose,
  ARROW: IconArrow,
  HEROES: IconHeroes,
  STAKED: IconLocked,
  REFRESH: IconRefresh,
  PROFILE: IconProfile,
  DISCORD: IconDiscord,
  OPEN_SEA: IconOpenSea,
  SKYBORNE: IconSkyborne,
  SWITCH_ON: IconSwitchOn,
  CHECKMARK: IconCheckmark,
  SWITCH_OFF: IconSwitchOff,
  DROPDOWN_ARROW: IconDropdownArrow,
  // Home
  HOME_TWITCH: IconTwitch,
  HOME_MEDIUM: IconMedium,
  HOME_TIKTOK: IconTiktok,
  HOME_DISCORD: IconDiscord2,
  HOME_TWITTER: IconTwitter,
  HOME_YOUTUBE: IconYoutube,
  HOME_FACEBOOK: IconFacebook,
  HOME_INSTAGRAM: IconInstagram,
  HOME_DISCORD_SMALL: IconDiscordSmall,
  HOME_TWITTER_SMALL: IconTwitterSmall,
  // Map
  MAP_INFO: IconMapInfo,
  MAP_BACKPACK: IconMapBackpack,
  MAP_SIDE_QUEST_PIN: IconMapSideQuestPin,
  MAP_MERGED_QUEST_PIN: IconMapMergedQuestPin,
  MAP_CAMPAIGN_QUEST_PIN: IconMapCampaignQuestPin,
  // Account
  ACCOUNT_INFO: IconAccountInfo,
  ACCOUNT_SETTINGS: IconAccountSettings,
  ACCOUNT_ACTIVITY: IconAccountActivity,
  ACCOUNT_BRIEFCASE: IconAccountBriefcase,
  ACCOUNT_SETTINGS_ACTIVE: IconAccountSettingsActive,
  ACCOUNT_ACTIVITY_ACTIVE: IconAccountActivityActive,
  ACCOUNT_BRIEFCASE_ACTIVE: IconAccountBriefcaseActive,
  // Heroes
  HERO_CHECKMARK: IconHeroCheckmark,
  // Quest
  QUESTS: IconQuests,
  QUEST_THEME: IconQuestTheme,
  QUEST_ADD_HERO: IconQuestAddHero,
  QUEST_DURATION: IconQuestDuration,
  QUEST_SMALL_INFO: IconQuestSmallInfo,
  QUEST_REMOVE_HERO: IconQuestRemoveHero,
  QUEST_THEME_LOCKED: IconQuestThemeLocked,
  QUEST_DURATION_BLUE: IconQuestDurationBlue,
  QUEST_THEME_COMPLETE: IconQuestThemeComplete,
  // Traits
  LEADER_TRUE: IconTraitLeader,
  RARITY_MYTHIC: IconTraitRarityMythic,
  RARITY_EPIC: IconTraitRarityEpic,
  RARITY_COMMON: IconTraitRarityCommon,
  RARITY_UNCOMMON: IconTraitRarityUncommon,
  RARITY_RARE: IconTraitRarityRare,
  RARITY_LEGENDARY: IconTraitRarityLegendary,
  SPECIES_DRAGONKIN: IconTraitSpeciesDragonkin,
  SPECIES_HUMAN: IconTraitSpeciesHuman,
  SPECIES_EMBERLING: IconTraitSpeciesEmberling,
  SPECIES_GNOME: IconTraitSpeciesGnome,
  SPECIES_ELF: IconTraitSpeciesElf,
  SPECIES_DWARF: IconTraitSpeciesDwarf,
  SPECIES_ORC: IconTraitSpeciesOrc,
  SPECIES_GOLIATH: IconTraitSpeciesGoliath,
  ELEMENTAL_AFFINITY_PYROFLAME: IconTraitElementalAffinityPyroflame,
  ELEMENTAL_AFFINITY_TERRAFIRM: IconTraitElementalAffinityTerrafirm,
  ELEMENTAL_AFFINITY_CYCLONIS: IconTraitElementalAffinityCyclonis,
  ELEMENTAL_AFFINITY_AQUASURGE: IconTraitElementalAffinityAquasurge,
  ELEMENTAL_AFFINITY_CRYONYX: IconTraitElementalAffinityCryonyx,
  ELEMENTAL_AFFINITY_VOLTANYX: IconTraitElementalAffinityVoltanyx,
  ELEMENTAL_AFFINITY_UMBRANYX: IconTraitElementalAffinityUmbranyx,
  ELEMENTAL_AFFINITY_SYLVANYX: IconTraitElementalAffinitySylvanyx,
  ELEMENTAL_AFFINITY_SOLPHAEON: IconTraitElementalAffinitySolphaeon,
  ELEMENTAL_AFFINITY_OBLIVAEON: IconTraitElementalAffinityOblivaeon,
  ELEMENTAL_TIER_1: IconTraitElementalTier1,
  ELEMENTAL_TIER_2: IconTraitElementalTier2,
  ELEMENTAL_TIER_3: IconTraitElementalTier3,
  RANK_1: IconTraitRank1,
  RANK_2: IconTraitRank2,
  RANK_3: IconTraitRank3,
  RANK_4: IconTraitRank4,
  RANK_5: IconTraitRank5,
  CLASS_FIGHTER: IconTraitClassFighter,
  CLASS_FIGHTER_RANK_1: IconTraitClassFighterRank1,
  CLASS_FIGHTER_RANK_2: IconTraitClassFighterRank2,
  CLASS_FIGHTER_RANK_3: IconTraitClassFighterRank3,
  CLASS_FIGHTER_RANK_4: IconTraitClassFighterRank4,
  CLASS_FIGHTER_RANK_5: IconTraitClassFighterRank5,
  CLASS_ROGUE: IconTraitClassRogue,
  CLASS_ROGUE_RANK_1: IconTraitClassRogueRank1,
  CLASS_ROGUE_RANK_2: IconTraitClassRogueRank2,
  CLASS_ROGUE_RANK_3: IconTraitClassRogueRank3,
  CLASS_ROGUE_RANK_4: IconTraitClassRogueRank4,
  CLASS_ROGUE_RANK_5: IconTraitClassRogueRank5,
  CLASS_CLERIC: IconTraitClassCleric,
  CLASS_CLERIC_RANK_1: IconTraitClassClericRank1,
  CLASS_CLERIC_RANK_2: IconTraitClassClericRank2,
  CLASS_CLERIC_RANK_3: IconTraitClassClericRank3,
  CLASS_CLERIC_RANK_4: IconTraitClassClericRank4,
  CLASS_CLERIC_RANK_5: IconTraitClassClericRank5,
  CLASS_DRUID: IconTraitClassDruid,
  CLASS_DRUID_RANK_1: IconTraitClassDruidRank1,
  CLASS_DRUID_RANK_2: IconTraitClassDruidRank2,
  CLASS_DRUID_RANK_3: IconTraitClassDruidRank3,
  CLASS_DRUID_RANK_4: IconTraitClassDruidRank4,
  CLASS_DRUID_RANK_5: IconTraitClassDruidRank5,
  CLASS_BARBARIAN: IconTraitClassBarbarian,
  CLASS_BARBARIAN_RANK_1: IconTraitClassBarbarianRank1,
  CLASS_BARBARIAN_RANK_2: IconTraitClassBarbarianRank2,
  CLASS_BARBARIAN_RANK_3: IconTraitClassBarbarianRank3,
  CLASS_BARBARIAN_RANK_4: IconTraitClassBarbarianRank4,
  CLASS_BARBARIAN_RANK_5: IconTraitClassBarbarianRank5,
  CLASS_MAGE: IconTraitClassMage,
  CLASS_MAGE_RANK_1: IconTraitClassMageRank1,
  CLASS_MAGE_RANK_2: IconTraitClassMageRank2,
  CLASS_MAGE_RANK_3: IconTraitClassMageRank3,
  CLASS_MAGE_RANK_4: IconTraitClassMageRank4,
  CLASS_MAGE_RANK_5: IconTraitClassMageRank5,
  CLASS_SORCERER: IconTraitClassSorcerer,
  CLASS_SORCERER_RANK_1: IconTraitClassSorcererRank1,
  CLASS_SORCERER_RANK_2: IconTraitClassSorcererRank2,
  CLASS_SORCERER_RANK_3: IconTraitClassSorcererRank3,
  CLASS_SORCERER_RANK_4: IconTraitClassSorcererRank4,
  CLASS_SORCERER_RANK_5: IconTraitClassSorcererRank5,
  CLASS_HUNTER: IconTraitClassHunter,
  CLASS_HUNTER_RANK_1: IconTraitClassHunterRank1,
  CLASS_HUNTER_RANK_2: IconTraitClassHunterRank2,
  CLASS_HUNTER_RANK_3: IconTraitClassHunterRank3,
  CLASS_HUNTER_RANK_4: IconTraitClassHunterRank4,
  CLASS_HUNTER_RANK_5: IconTraitClassHunterRank5,
  CLASS_MONK: IconTraitClassMonk,
  CLASS_MONK_RANK_1: IconTraitClassMonkRank1,
  CLASS_MONK_RANK_2: IconTraitClassMonkRank2,
  CLASS_MONK_RANK_3: IconTraitClassMonkRank3,
  CLASS_MONK_RANK_4: IconTraitClassMonkRank4,
  CLASS_MONK_RANK_5: IconTraitClassMonkRank5,
  CLASS_BARD: IconTraitClassBard,
  CLASS_BARD_RANK_1: IconTraitClassBardRank1,
  CLASS_BARD_RANK_2: IconTraitClassBardRank2,
  CLASS_BARD_RANK_3: IconTraitClassBardRank3,
  CLASS_BARD_RANK_4: IconTraitClassBardRank4,
  CLASS_BARD_RANK_5: IconTraitClassBardRank5,
  CLASS_PALADIN: IconTraitClassPaladin,
  CLASS_PALADIN_RANK_1: IconTraitClassPaladinRank1,
  CLASS_PALADIN_RANK_2: IconTraitClassPaladinRank2,
  CLASS_PALADIN_RANK_3: IconTraitClassPaladinRank3,
  CLASS_PALADIN_RANK_4: IconTraitClassPaladinRank4,
  CLASS_PALADIN_RANK_5: IconTraitClassPaladinRank5,
  WEAPON_TYPE_MAGIC_ITEM: IconTraitWeaponTypeMagicItem,
  WEAPON_TYPE_STAFF: IconTraitWeaponTypeStaff,
  WEAPON_TYPE_HEAVY: IconTraitWeaponTypeHeavy,
  WEAPON_TYPE_SWORD: IconTraitWeaponTypeSword,
  WEAPON_TYPE_RANGE: IconTraitWeaponTypeRange,
  WEAPON_TYPE_AXE: IconTraitWeaponTypeAxe,
  WEAPON_TYPE_DAGGERS: IconTraitWeaponTypeDaggers,
  WEAPON_TYPE_FISTS: IconTraitWeaponTypeFists,
  WEAPON_TYPE_INSTRUMENT: IconTraitWeaponTypeInstrument,
  WEAPON_TYPE_SPEAR: IconTraitWeaponTypeSpear,
  WEAPON_TIER_1: IconTraitWeaponTier1,
  WEAPON_TIER_2: IconTraitWeaponTier2,
  WEAPON_TIER_3: IconTraitWeaponTier3,
  WEAPON_TIER_4: IconTraitWeaponTier4,
  DAMAGE_TYPE_MAGIC: IconTraitDamageTypeMagic,
  DAMAGE_TYPE_BLUNT: IconTraitDamageTypeBlunt,
  DAMAGE_TYPE_SLASH: IconTraitDamageTypeSlash,
  DAMAGE_TYPE_PIERCE: IconTraitDamageTypePierce,
  ROLE_HEALER: IconTraitRoleHealer,
  ROLE_MELEE_DPS: IconTraitRoleMeleeDps,
  ROLE_SUPPORT: IconTraitRoleSupport,
  ROLE_RANGED_DPS: IconTraitRoleRangedDps,
  ROLE_TANK: IconTraitRoleTank,
  COMPANION_TRUE: IconTraitCompanion
};

const Image = {
  // Home
  HOME_LOGO_RG: ImgLogoRG,
  HOME_SKY_BG: ImgHomeSkyBG,
  HOME_CASTLE_BG: ImgCastleBG,
  HOME_DRAGON_BG: ImgDragonBG,
  HOME_TREE_DARK_FG: ImgTreeDarkFG,
  HOME_LOGO_GENESIS: ImgLogoGenesis,
  HOME_TREE_TOP_LEFT: ImgTreeTopLeft,
  HOME_TREE_TOP_RIGHT: ImgTreeTopRight,
  HOME_TREE_BOTTOM_LEFT: ImgTreeBottomLeft,
  HOME_TREE_BOTTOM_RIGHT: ImgTreeBottomRight,
  // Hero
  AVATAR_FRAME: ImgAvatarFrame,
  HERO_TITLE_MOTIF: ImgHeroTitleMotif,
  HERO_PLACEHOLDER: ImgHeroPlaceholder,
  // Backapck
  ITEM_PLACEHOLDER: ImgItemPlaceholder,
  // Account
  ACCOUNT_BG: ImgAccountBG,
  // Map
  MAP_WORLD: ImgMapWorld,
  MAP_REGION_BANNER: ImgMapRegionBanner,
  MAP_WORLD_LOW_QUALITY: ImgMapWorldLowQuality
};

// exports
export const ICON = Icon;
export const IMAGE = Image;
export default { ICON, IMAGE } as const;
